import { render, staticRenderFns } from "./detail_tab_nci.vue?vue&type=template&id=3f18221e&scoped=true"
import script from "./detail_tab_nci.vue?vue&type=script&lang=js"
export * from "./detail_tab_nci.vue?vue&type=script&lang=js"
import style0 from "./detail_tab_nci.vue?vue&type=style&index=0&id=3f18221e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f18221e",
  null
  
)

export default component.exports